"use strict";

exports.__esModule = true;
exports["default"] = ControlPrevious;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlPrevious(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.542 17.387h-4.297a1.392 1.392 0 0 1-1.396-1.393c0-.767.623-1.395 1.396-1.395h4.297a1.395 1.395 0 1 1 0 2.788zm-25.698.008h16.662c.773 0 1.404-.628 1.404-1.401 0-.771-.631-1.403-1.404-1.403H4.844l7.923-7.915a1.398 1.398 0 0 0 0-1.979 1.396 1.396 0 0 0-1.98 0L.469 15.005a1.419 1.419 0 0 0-.295.455 1.374 1.374 0 0 0 0 1.076c.07.168.176.321.295.452l10.318 10.309a1.38 1.38 0 0 0 1.98 0 1.398 1.398 0 0 0 0-1.979l-7.923-7.923z"
  }));
}